import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-offer', 'dismissOffer', 'Atmesti pasiūlymą');
